import React from 'react';
import { Progress } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobeAmericas } from '@fortawesome/free-solid-svg-icons';
import {
    createDataSource, createGridOptions, DataGrid, indexCellRenderer, LinkCellRenderer, TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { agGridConstants, ApiRoutes, AppNavPaths } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';

class PayScheduleIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    componentDidMount() {
        return this.populateState();
    }

    populateState = () => {
        const gridOptions = createGridOptions(this);

        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 70,
                minWidth: 70,
                maxWidth: 70,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'GoverningBody',
                sortable: true,
                headerName: 'Description',
                field: 'governingBody',
                flex: 0,
                width: 300,
                minWidth: 300,
                filter: agGridConstants.columnFilterTypes.text,
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                sort: { direction: 'asc', priority: 0 },
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    to: (id) => `${AppNavPaths.PayScheduleNew}/${id}`,
                    nameField: 'governingBody',
                    idField: 'id',
                    title: 'View this Group',
                },
            },
            {
                colId: 'State',
                sortable: false,
                headerName: 'State',
                field: 'state',
                flex: 0,
                width: 150,
                minWidth: 150,
            },
            {
                colId: 'Counties',
                sortable: false,
                headerName: 'Counties',
                field: 'counties',
                flex: 0,
                width: 500,
                minWidth: 300,
            },
            {
                colId: 'Reg',
                sortable: false,
                headerName: 'Reg',
                field: 'reg',
                flex: 0,
                width: 100,
                minWidth: 100,
            },
            {
                colId: 'OT',
                sortable: false,
                headerName: 'OT',
                field: 'ot',
                flex: 0,
                width: 100,
                minWidth: 100,
            },
            {
                colId: 'Fringe',
                sortable: false,
                headerName: 'Fringe',
                field: 'fringe',
                flex: 0,
                width: 100,
                minWidth: 100,
            },
        ];

        const ds = createDataSource(ApiRoutes.paySchedule.search(), gridOptions);

        this.setState({
            loading: false,
            gridOptions,
            dataSource: ds,
        });
    };

    render() {
        if (this.state.loading) return (<Progress />);
        const { rowData, gridOptions } = this.state;

        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faGlobeAmericas}
                        className="mr-2 text-muted"
                    />
                    <span>Pay Schedules</span>
                </PageHeading>
                <DataGridToolbar
                    entity="group"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    onAdd={() => this.context.history.push(`${AppNavPaths.PayScheduleNew}`)}
                    addLabel="Add Pay Schedule"
                    serverExportDisabled={false}
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
            </PageWrap>
        );
    }
}
export default PayScheduleIndex;
